export default "__VITE_PUBLIC_ASSET__b5d9506d__"